import {useAxiosAuth} from "@/hooks/useAxiosAuth.ts";
import {useMutation} from "@tanstack/react-query";
import {ApiConfig} from "@/config/api.config.ts";
import {AxiosError} from "axios";
import {ProblemDetails} from "@/@types/base.types.ts";

type Props = {
    onSuccess?: () => void;
    onError?: (error: AxiosError<ProblemDetails>) => void;
}

type DoSetPasswordProps = {
    token: string;
    newPassword: string;
}

export const useSetPasswordApi = ({onSuccess, onError}: Props) => {
    const axiosInstance = useAxiosAuth();

    const {mutateAsync: doSetPassword, isPending: isDoSetPasswordPending} = useMutation({
        mutationFn: async ({token, newPassword}: DoSetPasswordProps) => {
            const response = await axiosInstance
                .post(ApiConfig.queries.auth.setPassword.endpoint, {
                    token,
                    newPassword
                });
            return response.data;
        },
        onSuccess: () => {
            onSuccess?.();
        },
        onError: (error: AxiosError<ProblemDetails>) => {
            onError?.(error);
        }
    })

    return {
        doSetPassword,
        isDoSetPasswordPending,
    }
}